// extracted by mini-css-extract-plugin
export default {"albumCard":"AlbumCard_albumCard__wX5bE","albumCover":"AlbumCard_albumCover__l7WKb"};